import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiAxios from 'helpers/apiAxios';
import { toast } from 'react-toastify';

const BASE = '/my/calendar_events';

export const fetchCalendarEvents = createAsyncThunk(
  'MyCalendar/fetchEvents',
  async (params = {}, { rejectWithValue }) => {
    try {
      const res = await apiAxios.get(BASE, { params });
      return res.data;
    } catch (e) { return rejectWithValue(e.response?.data); }
  }
);

export const createCalendarActivity = createAsyncThunk(
  'MyCalendar/create',
  async (data, { rejectWithValue }) => {
    try {
      const res = await apiAxios.post(BASE, { activity: data });
      return res.data;
    } catch (e) { return rejectWithValue(e.response?.data); }
  }
);

export const updateCalendarActivity = createAsyncThunk(
  'MyCalendar/update',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await apiAxios.patch(`${BASE}/${id}`, { activity: data });
      return res.data;
    } catch (e) { return rejectWithValue(e.response?.data); }
  }
);

export const deleteCalendarActivity = createAsyncThunk(
  'MyCalendar/delete',
  async (id, { rejectWithValue }) => {
    try {
      await apiAxios.delete(`${BASE}/${id}`);
      return id;
    } catch (e) { return rejectWithValue(e.response?.data); }
  }
);

const calendarSlice = createSlice({
  name: 'my_calendar',
  initialState: {
    events:      [],
    loading:     false,
    submitting:  false,
    error:       null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // fetch
      .addCase(fetchCalendarEvents.pending,  (s) => { s.loading = true; s.error = null; })
      .addCase(fetchCalendarEvents.fulfilled, (s, a) => { s.loading = false; s.events = a.payload.events || []; })
      .addCase(fetchCalendarEvents.rejected,  (s, a) => { s.loading = false; s.error = a.payload; })
      // create
      .addCase(createCalendarActivity.pending,  (s) => { s.submitting = true; })
      .addCase(createCalendarActivity.fulfilled, (s, a) => {
        s.submitting = false;
        if (a.payload.event) s.events = [...s.events, a.payload.event];
        toast.success('Activity created.');
      })
      .addCase(createCalendarActivity.rejected, (s, a) => {
        s.submitting = false;
        toast.error(a.payload?.error?.[0] || 'Failed to create activity.');
      })
      // update
      .addCase(updateCalendarActivity.pending,  (s) => { s.submitting = true; })
      .addCase(updateCalendarActivity.fulfilled, (s, a) => {
        s.submitting = false;
        const ev = a.payload.event;
        if (ev) s.events = s.events.map(e => e.id === ev.id ? ev : e);
        toast.success('Activity updated.');
      })
      .addCase(updateCalendarActivity.rejected, (s, a) => {
        s.submitting = false;
        toast.error(a.payload?.error?.[0] || 'Failed to update activity.');
      })
      // delete
      .addCase(deleteCalendarActivity.pending,  (s) => { s.submitting = true; })
      .addCase(deleteCalendarActivity.fulfilled, (s, a) => {
        s.submitting = false;
        s.events = s.events.filter(e => e.id !== `activity-${a.payload}`);
        toast.success('Activity deleted.');
      })
      .addCase(deleteCalendarActivity.rejected, (s) => { s.submitting = false; });
  },
});

export default calendarSlice.reducer;
